import React, { useState, useCallback } from 'react';
import { useKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts';
import { ShortcutHelpOverlay } from '@/components/keyboard/ShortcutHelpOverlay';
import {
  ShortcutContext,
  ShortcutContextType,
} from './shortcut-context-definition';

interface ShortcutProviderProps {
  children: React.ReactNode;
}

export function ShortcutProvider({ children }: ShortcutProviderProps) {
  const [isHelpVisible, setIsHelpVisible] = useState(false);

  const showHelp = useCallback(() => setIsHelpVisible(true), []);
  const hideHelp = useCallback(() => setIsHelpVisible(false), []);
  const toggleHelp = useCallback(() => setIsHelpVisible((prev) => !prev), []);

  // Global shortcuts
  useKeyboardShortcuts('global', [
    {
      key: '?',
      description: 'Show keyboard shortcuts help',
      action: toggleHelp,
      category: 'Global',
      modifiers: { shift: true },
    },
    {
      key: 'Escape',
      description: 'Close help overlay',
      action: hideHelp,
      category: 'Global',
      disabled: !isHelpVisible,
    },
  ]);

  const value: ShortcutContextType = {
    showHelp,
    hideHelp,
    toggleHelp,
    isHelpVisible,
  };

  return (
    <ShortcutContext value={value}>
      {children}
      <ShortcutHelpOverlay isOpen={isHelpVisible} onClose={hideHelp} />
    </ShortcutContext>
  );
}
